<div class="panel panel-info">
  <div
    class="panel-heading"
    [ngStyle]="{ 'border-bottom': opened ? 'none' : '1px solid #dddddd' }"
    (click)="toggle.emit()"
  >
    <span class="triangulo" [ngClass]="{ open: opened }"></span>
    <span> {{ title }} </span>
  </div>
  <div class="panel-body" *ngIf="opened">
    <div class="horarios">
      <ng-content></ng-content>
    </div>
  </div>
  <div></div>
</div>
